import { EventEmitter, Injectable } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { HubConnection } from "@microsoft/signalr";
import { AppConsts } from "@shared/AppConsts";
import { UtilsService } from "abp-ng2-module/dist/src/utils/utils.service";
import { Consumers } from "./service-proxies";
import { AbpSessionService } from "abp-ng2-module/dist/src/session/abp-session.service";

class billsResult {
    tenantId: number;
    exteraEntity: Consumers;
    billsId: number[];
    newBill: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class SignalrService {

    constructor(
        private _sessionService: AbpSessionService,
    ) { }
    orderList: EventEmitter<any> = new EventEmitter();
    basket: EventEmitter<any> = new EventEmitter();
    bill: EventEmitter<any> = new EventEmitter();
    advancedSearchBill: EventEmitter<any> = new EventEmitter();
    followUp: EventEmitter<any> = new EventEmitter();
    dashboard: EventEmitter<any> = new EventEmitter();
    accounting: EventEmitter<any> = new EventEmitter();
    sacrifice: EventEmitter<any> = new EventEmitter();
    postmanTask: EventEmitter<any> = new EventEmitter();
    virtualCredit: EventEmitter<any> = new EventEmitter();
    notification: EventEmitter<any> = new EventEmitter();
    condolenceMessage: EventEmitter<any> = new EventEmitter();
    ceremony: EventEmitter<any> = new EventEmitter();
    deceased: EventEmitter<any> = new EventEmitter();
    location: EventEmitter<any> = new EventEmitter();
    connection!: HubConnection;
    baseUrl = AppConsts.remoteServiceBaseUrl;



    createHubConnection(): void {
        let encryptedAuthToken = new UtilsService().getCookieValue(AppConsts.authorization.encrptedAuthTokenName);
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.baseUrl + "/signalr-refresh")
            .withAutomaticReconnect()
            .build();

        this.connection.on("orderListRefreshed", () => {
            this.orderList.emit();
        });
        this.connection.on("basketRefreshed", () => {
            this.basket.emit();
        });
        this.connection.on("billRefreshed", (result: billsResult) => {
            // console.log('result',result);

            if (result.tenantId == this._sessionService.tenantId) {
                this.bill.emit(result.exteraEntity);
                this.advancedSearchBill.emit(result);
            }
        });
        this.connection.on("followUpRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.followUp.emit();
            }
        });
        this.connection.on("dashboardRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.dashboard.emit();
            }
        });
        this.connection.on("accountingRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.accounting.emit();
            }
        });
        this.connection.on("sacrificesRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.sacrifice.emit();
            }
        });
        this.connection.on("postmanTasksRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.postmanTask.emit();
            }
        });
        this.connection.on("virtualCreditRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.virtualCredit.emit();
            }
        });
        this.connection.on("notificationRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.notification.emit();
            }
        });
        this.connection.on("condolenceMessageRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.condolenceMessage.emit();
            }
        });
        this.connection.on("ceremonyRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.ceremony.emit();
            }
        });
        this.connection.on("deceasedRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.deceased.emit();
            }
        });
        this.connection.on("locationRefreshed", (result: number) => {
            if (result == this._sessionService.tenantId) {
                this.location.emit();
            }
        });
        this.startConnection();

    }

    startConnection(): void {
        if (this.connection.state === "Disconnected") {
            this.connection.start()
                .then(() => {
                    if (this.connection.state !== "Connected") {
                        setTimeout(() => {
                            this.connection.start();
                        }, 5000);
                    }

                })
                .catch(error => {
                    if (this.connection.state !== "Connected") {
                        setTimeout(() => {
                            this.connection.start();
                        }, 5000);
                    }
                    console.log(error);
                })
                .finally(() => {
                    // console.log('this.connection', this.connection);
                })
        }
    }

}